// app/assets/javascripts/attendance_concerns.js - VERSÃO OTIMIZADA

// Cache para verificar se selectpicker está inicializado
const selectPickerCache = new WeakMap();

// Função auxiliar para fazer refresh correto do selectpicker
const refreshSelectPicker = (element) => {
  if (!element) return;

  try {
    // Usa a forma específica de acessar o selectpicker
    let [refEl] = Object.values(element).filter(a => a?.liveSearch && a);
    if (refEl && refEl.selectpicker) {
      requestAnimationFrame(() => {
        refEl.selectpicker.refresh();
      });
      return true;
    }
  } catch (error) {
    console.warn('Erro ao atualizar selectpicker:', error);
  }

  // Fallback para método tradicional
  if (typeof $ !== 'undefined' && $(element).data('selectpicker')) {
    requestAnimationFrame(() => {
      $(element).selectpicker('refresh');
    });
    return true;
  }

  return false;
};

export const enableSelect = (element) => {
  if (!element) return;

  element.disabled = false;
  refreshSelectPicker(element);
};

export const disableSelect = (element) => {
  if (!element) return;

  element.disabled = true;
  refreshSelectPicker(element);
};

export const clearSelectElTarget = (element, placeholder) => {
  if (!element) return;

  element.innerHTML = `<option value="">${placeholder}</option>`;
  refreshSelectPicker(element);
};

export const clearEl = (element) => {
  if (!element) return;
  element.innerHTML = '';
};

// Função auxiliar para verificar se o elemento tem selectpicker
const hasSelectPicker = (element) => {
  // Usa cache para evitar verificações repetidas
  if (selectPickerCache.has(element)) {
    return selectPickerCache.get(element);
  }

  // Verifica usando o método específico primeiro
  try {
    let [refEl] = Object.values(element).filter(a => a?.liveSearch && a);
    if (refEl && refEl.selectpicker) {
      selectPickerCache.set(element, true);
      return true;
    }
  } catch (error) {
    // Ignora erro e tenta método tradicional
  }

  // Fallback para método tradicional
  const hasIt = typeof $ !== 'undefined' && $(element).data('selectpicker');
  selectPickerCache.set(element, !!hasIt);

  return !!hasIt;
};

// Função para atualizar múltiplos selects de uma vez (batch update)
export const batchUpdateSelects = (updates) => {
  requestAnimationFrame(() => {
    updates.forEach(({ element, action, ...params }) => {
      switch (action) {
        case 'enable':
          enableSelect(element);
          break;
        case 'disable':
          disableSelect(element);
          break;
        case 'clear':
          clearSelectElTarget(element, params.placeholder);
          break;
      }
    });
  });
};